import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import PreviewIcon from '@mui/icons-material/Preview';
import LzCModule from '@lz-modules/Module';
import SummaryOfSalesInvoicesReport from './SummaryOfSalesInvoices';
import SummaryOfSalesInvoicesPrint from './SummaryOfSalesInvoices/print';

// Create the module and use the customized entities in it
const ReportsModule = new LzCModule({
    ident: 'reports',
    name: 'Reports',
    icon: <PreviewIcon />,
    children: [
        {
            variation: 'Report',
            ident: 'summary-of-sales-invoices',
            icon: <ReceiptLongIcon />,
            reportComponent: <SummaryOfSalesInvoicesReport />
        },
    ],
    routes: [
        { path: '/reports/summary-of-sales-invoices-print/:fbr_pending_status/:start_date/:end_date', element: <SummaryOfSalesInvoicesPrint /> },
    ],
});

export default ReportsModule;
